<template>
	<div class="content-box">
		<div class="article-div">
			<template v-if="detail.title">
				<p class="article-title">{{ detail.title }}</p>
				<p class="article-info">
					<span class="article-time">{{ detail.publishTime }}</span>
					<span class="article-author">{{ detail.authorNick }}</span>
				</p>
				<div class="article-content">
					<div v-for="(item, index) in detail.content" :key="index">
						<p v-if="item.entityType == 'ResourceText'">{{ item.textDescription }}</p>
						<img v-if="item.entityType == 'ResourcePic'" :src="item.resourceUrl" />
						<div v-if="item.entityType == 'ResourceItem'">
							<div class="cst-product">
								<div class="goods-love-list s-row" @click="toDetail(item.itemId, detail['itemInfoMap'][item.itemId]['linkType'])">
									<div class="image"><img :src="item.itemCoverUrl" /></div>
									<div class="content">
										<div class="title">{{ item.itemTitle }}</div>

										<div class="product-volume">来自{{ detail['itemInfoMap'][item.itemId]['linkType'] == '1' ? '天猫' : '淘宝' }}</div>
										<div class="product-coupon">
											<div class="coupon-money" v-if="detail['itemInfoMap'][item.itemId]['couponAmount']">
												<span>{{ detail['itemInfoMap'][item.itemId]['couponAmount'] }}元券</span>
											</div>

											<div class="product-shouyi" v-if="detail['itemInfoMap'][item.itemId]['couponAmount']">
												<span>券后价{{ detail['itemInfoMap'][item.itemId]['discountCouponPrice'] }}</span>
											</div>
											<div class="product-shouyi" v-else>
												<span>优惠价{{ detail['itemInfoMap'][item.itemId]['discountPrice'] }}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<van-tag type="danger" style="margin: 2px 5px; " size="medium" v-for="(tag, tIndex) in detail.tags" :key="tIndex">{{ tag }}</van-tag>
				</div>

				<div class="open-side-btn " @click="showPopup">{{ detail.itemCount }}个宝贝</div>

				<van-popup v-model="show" position="right" :style="{ width: '80%', height: '100%' }">
					<div class="cst-product">
						<div class="goods-love-list s-row" v-for="(item, index) in detail.itemInfoMap" :key="index" @click="toDetail(item.itemId, item['linkType'])">
							<div class="image" style="width: 100px;height: 100px;    max-width: 30%;"><img style="width: 100px;height: 100px;" :src="item.picUrl" /></div>
							<div class="content" style="width: 64%;">
								<div class="title">{{ item.title }}</div>

								<div class="product-volume">来自{{ item.linkType == '1' ? '天猫' : '淘宝' }}</div>
								<div class="product-coupon">
									<div class="coupon-money" v-if="item.couponAmount">
										<span>{{ item.couponAmount }}元券</span>
									</div>

									<div class="product-shouyi" v-if="item.discountCouponPrice">
										<span>券后价{{ item.discountCouponPrice }}</span>
									</div>
									<div class="product-shouyi" v-else>
										<span>优惠价{{ item.discountPrice }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</van-popup>
			</template>
		</div>
	</div>
</template>

<script>
import cstGoods from '@/components/product.vue';
export default {
	data() {
		return {
			detail: {},
			show: false
		};
	},
	components: {
		cstGoods
	},
	created() {
		var params = this.$route.query;
		if (!params.contentId) {
			suni.showToast({
				title: '文章不存在',
				success: err => {
					suni.navigateBack();
				}
			});
			return false;
		}
		if (!params.publishTime) {
			suni.showToast({
				title: '文章不存在',
				success: err => {
					suni.navigateBack();
				}
			});
			return false;
		}
		this.get_content(params);
	},
	methods: {
		showPopup() {
			this.show = true;
		},
		get_content(params) {
			this.$Request.post('dapei/detail', params).then(res => {
				if (res.code == 200) {
					
					suni.postMessage({
						data: {
							action: 'api',
							methods:"setNavigationBarTitle",
							params:{
								title:res.data.title
							}
						}
					});
					this.detail = res.data;
				} else {
					suni.showToast({
						title: res.msg || '文章不存在',
						success: err => {
							suni.navigateBack();
						}
					});
				}
			});
		},
		toDetail(itemid, type) {
			suni.navigateTo({
				url: '/pages/detail/goodsinfo?itemid=' + itemid + '&goods_type=' + (type == 1 ? type : '2')
			}).catch(err => {
				suni.showToast({
					title: '打开商品详情失败',
					success: err => {
						suni.navigateBack();
					}
				});
			});
		}
	}
};
</script>

<style>
p {
	margin: 5px 0;
}
.content-box {
	width: 100%;
	color: #767676;
	font-size: 14px;
}
.article-div {
	padding: 10px;
}
.article-title {
	color: #4a4a4a;
	font-size: 16px;
}

.article-time {
	margin-right: 10px;
}
.article-author,
.article-time {
	color: #9b9b9b;
	font-size: 14px;
}
.article-content {
}
img {
	border: 0 none;
	width: auto\9;
	height: auto;
	max-width: 100%;
	vertical-align: top;
	-ms-interpolation-mode: bicubic;
	background: rgb(245, 245, 245);
}

.product-coupon {
	margin-top: 20px;
}
.open-side-btn {
	position: fixed;
	right: 0;
	bottom: 10%;
	height: 36px;
	background: url(//gw.alicdn.com/tfs/TB1kZ8ybRxRMKJjy0FdXXaifFXa-171-72.png);
	background-size: cover;
	line-height: 1;
	color: #fff;
	box-sizing: border-box;
	z-index: 9;
	font-size: 12px;
	padding: 10px 10px 10px 35px;
	cursor: pointer;
}
</style>
